import React from "react";
import { FiArrowLeft, FiSave } from "react-icons/fi";

const BankSetupHeader = ({ onBack, handleSubmit, loading }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div>
        <div className="bma-breadcrumb">
          Home &nbsp;&gt;&nbsp; Casting Directors &nbsp;&gt;&nbsp; Payment Master &nbsp;&gt;&nbsp; <strong>Master Form</strong>
        </div>
        <h1 className="bma-page-title">Payment Master – Casting Director</h1>
        <p className="bma-page-subtitle">Manage bank account and settlement preferences for Casting Director.</p>
      </div>
      <div className="d-flex gap-2">
        {onBack && (
          <button type="button" className="bma-btn-outline" onClick={onBack}>
            <FiArrowLeft /> Back
          </button>
        )}
        
      </div>
    </div>
  );
};

export default BankSetupHeader;